import React, { useState } from 'react';
import VarietyDetailModal from './VarietyDetailModal';
import { isResolvedVarietySoldOut } from '../utils/productAvailability';
import VarietyGroupTabs from './VarietyGroupTabs';
import { ALL_VARIETY_GROUP_ID, filterVarietiesByGroup } from '../utils/varietyGroups';

const VarietyModal = ({ product, onClose, promotionNow }) => {
  const [selectedVariety, setSelectedVariety] = useState(null);
  const [activeVarietyGroupId, setActiveVarietyGroupId] = useState(ALL_VARIETY_GROUP_ID);
  React.useEffect(() => {
    setActiveVarietyGroupId(ALL_VARIETY_GROUP_ID);
  }, [product?.id]);
  const truncateText = (value, maxLength = 88) => {
    const text = String(value || '').trim();
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return `${text.slice(0, maxLength - 1)}…`;
  };
  const resolveVarietyDescription = (variety) => {
    const varietyDescription = String(variety?.description || '').trim();
    if (varietyDescription) return varietyDescription;
    const priceDescription = (variety?.VarietyPrices || [])
      .map((price) => String(price?.description || '').trim())
      .find(Boolean);
    return priceDescription || '';
  };
  const hasSellablePrice = (variety) =>
    (variety.VarietyPrices || []).some((price) => price.price !== null && price.price !== undefined);
  const isVarietySoldOut = isResolvedVarietySoldOut;
  const visibleVarieties = filterVarietiesByGroup(
    (product.Varieties || []).filter((variety) => hasSellablePrice(variety)),
    product.VarietyGroups,
    activeVarietyGroupId
  );

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40 px-4"
        onClick={(event) => event.stopPropagation()}
      >
        <div
          className="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full max-h-[80vh] overflow-y-auto relative"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-600 hover:text-black bg-gray-200 hover:bg-gray-300 p-2 rounded-full transition-all"
          >
            ✕
          </button>

          {/* Modal Title */}
          <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-center">
            Variedades de {product.productName}
          </h2>

          <VarietyGroupTabs
            groups={product.VarietyGroups}
            activeGroupId={activeVarietyGroupId}
            onSelect={setActiveVarietyGroupId}
            className="mb-4"
          />

          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            {visibleVarieties.map((variety, index) => {
              const soldOut = isVarietySoldOut(variety);
              const varietyDescription = truncateText(resolveVarietyDescription(variety), 88);

              return (
                <div
                  key={index}
                  className={`relative bg-white border rounded-lg shadow p-4 cursor-pointer hover:bg-gray-50 ${
                    soldOut ? 'opacity-70' : ''
                  }`}
                  onClick={() => setSelectedVariety(variety)}
                >
                  <div className="flex items-center gap-4 md:gap-8 mb-2">
                    <img
                      src={variety.varietyImage || product.productImage || 'https://placehold.co/100'}
                      alt={variety.varietyName}
                      className="w-16 h-16 object-cover rounded-lg shadow"
                    />
                    <p className="text-sm font-medium text-gray-700 mt-2">{variety.varietyName}</p>

                  </div>
                  {varietyDescription && (
                    <p
                      className="text-xs text-gray-500 break-words min-h-[2.5rem] mb-2"
                      title={resolveVarietyDescription(variety)}
                    >
                      {varietyDescription}
                    </p>
                  )}
                  <div className="flex justify-between text-sm">
                    {soldOut ? (
                      <span className="text-red-600 text-md font-bold">AGOTADO</span>
                    ) : <span className="text-md font-semibold">[Ver Detalle]</span>
                    }
                  </div>
                </div>
              )
            })}
            {visibleVarieties.length === 0 && (
              <p className="text-sm text-gray-500">No hay variedades para este grupo.</p>
            )}
          </div>
        </div>
      </div>

      {selectedVariety && (
        <VarietyDetailModal
          variety={selectedVariety}
          onClose={() => setSelectedVariety(null)}
          handleClick={null}
          promotionNow={promotionNow}
        />
      )}
    </>
  );
};

export default VarietyModal;
